var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 7.82115H4.0428L10.3952 2.39258C10.4968 2.30508 10.4352 2.14258 10.3009 2.14258H8.69558C8.62483 2.14258 8.55772 2.16758 8.50511 2.21222L1.65021 8.06758C1.58742 8.12115 1.53707 8.18739 1.50256 8.26179C1.46805 8.3362 1.4502 8.41704 1.4502 8.49883C1.4502 8.58062 1.46805 8.66146 1.50256 8.73587C1.53707 8.81027 1.58742 8.8765 1.65021 8.93008L8.54502 14.8211C8.57223 14.8444 8.60488 14.8569 8.63934 14.8569H10.2991C10.4333 14.8569 10.495 14.6926 10.3934 14.6069L4.0428 9.17829H14.6562C14.736 9.17829 14.8013 9.11401 14.8013 9.03544V7.96401C14.8013 7.88544 14.736 7.82115 14.6562 7.82115Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.5b61a974220ebc60466e6378bf41ff39.svg";
export { ForwardRef as ReactComponent };